import { createContext, useContext } from 'react';

import { SeamlessResizeControllerContextValue } from './SeamlessResizeController.types';

export const SeamlessResizeControllerContext =
    createContext<SeamlessResizeControllerContextValue | null>(null);

export const useSeamlessResizeControllerContext = (): SeamlessResizeControllerContextValue => {
    const context = useContext(SeamlessResizeControllerContext);

    if (!context) {
        throw new Error(
            'useSeamlessResizeControllerContext must be used within SeamlessResizeController'
        );
    }

    return context;
};
